import { X } from "lucide-react";

const PALETTE = [
  "bg-amber-100 text-amber-900 border-amber-300",
  "bg-sky-100 text-sky-900 border-sky-300",
  "bg-emerald-100 text-emerald-900 border-emerald-300",
  "bg-rose-100 text-rose-900 border-rose-300",
  "bg-violet-100 text-violet-900 border-violet-300",
  "bg-lime-100 text-lime-900 border-lime-300",
  "bg-orange-100 text-orange-900 border-orange-300",
  "bg-teal-100 text-teal-900 border-teal-300",
];

export const tagColor = (name) => {
  let h = 0;
  for (const c of name.toLowerCase()) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
};

export function TagChip({ name, active, count, onClick, onRemove, testId }) {
  const Tag = onClick ? "button" : "span";
  return (
    <Tag type={onClick ? "button" : undefined} data-testid={testId} onClick={onClick}
      className={`inline-flex items-center gap-1 border px-2 py-0.5 text-[11px] font-medium leading-5 transition-colors ${tagColor(name)} ${active ? "ring-2 ring-foreground ring-offset-1" : ""} ${onClick ? "hover:brightness-95" : ""}`}>
      #{name}{count != null && <span className="opacity-60">· {count}</span>}
      {onRemove && (
        <button type="button" aria-label={`Remove tag ${name}`} data-testid={`${testId}-remove`} onClick={(e) => { e.stopPropagation(); onRemove(); }} className="ml-0.5 opacity-60 hover:opacity-100">
          <X className="w-3 h-3" />
        </button>
      )}
    </Tag>
  );
}
